import React, { useState, useEffect } from "react";
import {
  FormGroup,
  FormSelect,
  Row,
  Col,
  Badge,
  Nav,
  NavItem,
  NavLink,
} from "shards-react";
import ReactPaginate from "react-paginate";
import dayjs from "dayjs";
import "dayjs/locale/th";
import baseUrl from "config/baseUrl";
import useToken from "shared/hook/useToken";
import Layout from "shared/container/LayoutAdmin";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faClock,
  faCheck,
  faTrash,
  faListUl,
} from "@fortawesome/free-solid-svg-icons";
import {
  SelectIndicatorsDatasetKeyin,
  SelectIndicatorsDatasetKeyinTabs,
  ModalConfirm,
  SelectAgencyPowerBi,
} from "shared/components";
import { Loading } from "views/PowerbiSetting/components";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useCurrentUser from "shared/hook/useCurrentUser";

const PowerbiApprove = (props) => {
  const { token } = useToken();
  const { curruntUser } = useCurrentUser();
  const [userType, setUserType] = useState(0);
  const [userId, setUserId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isOpenModalAlert, SetOpenModalAlert] = useState(false);
  const [textAlertModal, setTextAlertModal] = useState(null);
  const [agencyId, setAgencyId] = useState(null);
  const [indicatorsDatasetId, setIndicatorsDatasetId] = useState(null);
  const [tableTabSettingId, setTableTabSettingId] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [PowerbiApproveData, setPowerbiApproveData] = useState(null);
  const [PowerbiDeleteData, setPowerbiDeleteData] = useState(null);
  const [status, setStatus] = useState(null);
  const [total, setTotal] = useState(0);
  const [yearId, setyearId] = useState(null);
  const [yearNo, setyearNo] = useState(null);
  const [indicatorsYearsList, setIndicatorsYears] = useState([]);
  const [ yearList , setYearList ] = useState(null);

  const showNotify = (message, type) => {
    switch (type) {
      case "success":
        toast.success(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      case "error":
        toast.error(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      case "warn":
        toast.warn(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      case "info":
        toast.info(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      default:
        toast.success(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
    }
  };

  const axios = require("axios").default;
  // อนุมัติ
  const onGetData = () => {
    setLoading(true);
    var data = JSON.stringify({
      params: {
        tableTabSettingId: tableTabSettingId == 0 ? null : tableTabSettingId,
        indicatorsDatasetSettingId:
          indicatorsDatasetId == 0 ? null : indicatorsDatasetId,
        "table_head_data.agencyId": agencyId == 0 ? null : agencyId,
        status: status != null ? `${status}` : null,
        yearNo: yearId == 0 ? null : Number(yearNo),
      },
      show: 30,
      page: pageNumber,
      orderBy: "tableHeadId",
      orderType: "DESC",
    });

    var config = {
      method: "post",
      url: `${baseUrl}/v1/setting-table/listhead`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then(function(response) {
        console.log("setting-table/listhead",response.data)
        setLoading(false);
        setPowerbiApproveData(response.data);
        setTotalPage(response.data.totalPage);
        setTotal(response.data.totalDocument);
      })
      .catch(function(error) {
        setLoading(false);
        console.log("setting-table/listhead", error);
      });
  };

  const onDeleteTable = () => {
    var data = JSON.stringify({
      params: {
        tableHeadId: PowerbiDeleteData.tableHeadId,
        indicatorsDatasetSettingId:
          PowerbiDeleteData.indicatorsDatasetSettingId,
        yearId: PowerbiDeleteData.yearId[0],
      },
      update: {
        status: 2,
      },
    });
    var config = {
      method: "post",
      url: `${baseUrl}/v1/setting-table/updatehead`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then(function(response) {
        SetOpenModalAlert(false);
        setPowerbiDeleteData(null);
        onGetData();
        showNotify("แจ้งเตือน! ลบข้อมูลเรียบร้อย");
      })
      .catch(function(error) {
        SetOpenModalAlert(false);
        setPowerbiDeleteData(null);
        onGetData();
        if (error.response.data.message) {
          showNotify(error.response.data.message, "error");
        } else {
          showNotify(error.message, "error");
        }
        console.log(`setting-table/updatehead`, error.message);
      });
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case 1:
        return <Badge theme="success">ข้อมูลเผยแพร่</Badge>;
      case 2:
        return <Badge theme="danger"> ลบแล้ว</Badge>;
      default:
        return <Badge theme="dark">รอเผยแพร่</Badge>;
    }
  };

  const nextPage = (page, total_page) => {
    setPageNumber(page + 1);
    setTotalPage(total_page);
  };

  const formatDate = (date) => {
    const split = date
      .replace("T", " ")
      .replace(".000Z", "")
      .split(" ");
    return `${dayjs(split[0]).format("DD/MM/YYYY")} ${split[1]}`;
  };

  const tab = [
    {
      title: "รอเผยแพร่",
      icon: <FontAwesomeIcon icon={faClock} />,
    },
    {
      title: "ข้อมูลเผยแพร่",
      icon: <FontAwesomeIcon icon={faCheck} />,
    },
    {
      title: "ลบแล้ว",
      icon: <FontAwesomeIcon icon={faTrash} />,
    },
  ];

  const selectTabs = (status) => {
    setStatus(status);
  };

  const getYearList = () => {
    const axios = require("axios").default;
    var data = JSON.stringify({
      "show": 100,
      "page": 1,
      "orderBy": "yearId",
      "orderType": "DESC"
    });
 
    var config = {
      method: 'post',
      url: `${baseUrl}/v1/setting-table/listyear`,
      headers: { 
        'Authorization': `Bearer ${token}`, 
        'Content-Type': 'application/json'
      },
      data : data
    };
    axios(config).then(function (response) {
      setYearList(response.data.data);
    })
    .catch(function (error) {
      console.log("setting-table/listyear",error);
    });
  };

  const getIndicatorsYears = () => {
    var data = JSON.stringify({
      indicatorsDatasetSettingId: indicatorsDatasetId,
      tableTabSettingId: tableTabSettingId,
    });
    var config = {
      method: "post",
      url: `${baseUrl}/v1/setting-table/yeargroupheadtable`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then(function(response) {
        const result = Object.keys(response.data).map(key => response.data[key].yearNo);
        const filterYear =  yearList.filter(item => {
            if(result.includes(item.yearNo)){
              return item;
            }
          });
        setIndicatorsYears(filterYear);
      })
      .catch(function(error) {
        console.log("/v1/setting-table/yeargroupheadtable", error);
      });
  };

  const getMonthName = (no) =>{
    const names=  [ "มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"];
    return names[Number(no)-1];
  }

  useEffect(() => {
    // onGetData();
  }, []);

  useEffect(() => {
    if (curruntUser) {
      setUserType(curruntUser.detail.userType);
      setAgencyId(curruntUser.detail.agencyId);
      setUserId(curruntUser.detail.userId);
    }
  }, [curruntUser]);

  useEffect(() => {
    onGetData();
  }, [pageNumber, indicatorsDatasetId, agencyId, tableTabSettingId, status, yearId]);

  useEffect(() => {
    getYearList();
    getIndicatorsYears();
  }, [indicatorsDatasetId, tableTabSettingId]);

  return (
    <Layout>
      {loading && <Loading />}
      <ToastContainer />
      <ModalConfirm
        show={isOpenModalAlert}
        titleHeader={`แจ้งเตือน! ยืนยันการลบข้อมูล`}
        onPressButtonConfirm={() => onDeleteTable()}
        onPressButtonCancel={() => SetOpenModalAlert(false)}
        onHide={() => SetOpenModalAlert(false)}
      >
        {textAlertModal}
      </ModalConfirm>
      <Row>
        <Col md="12">
          <h5 style={{ marginBottom: "30px" }}>
            {userType == 3 ? "จัดการข้อมูล" : "จัดการข้อมูลและอนุมัติเผยแพร่ข้อมูล"}
          </h5>
        </Col>
      </Row>
      <Row>
        <Col md="4">
          <FormGroup>
            <label>ชื่อหน่วยงาน</label>
            <SelectAgencyPowerBi
              placeholder="เลือก"
              name="agencyId"
              onChange={(e) => {
                setPageNumber(1);
                setAgencyId(e.target.value);
              }}
              defaultValue={agencyId}
              value={agencyId}
              userId={userType == 3 || userType == 4 ? userId : null}
            />
          </FormGroup>
        </Col>
        <Col md="4">
          <FormGroup>
            <label>ข้อมูล/ตัวชี้วัด</label>
            <SelectIndicatorsDatasetKeyin
              placeholder="เลือก"
              disabled={agencyId == null || agencyId == 0}
              name="indicatorsDatasetId"
              onChange={(e) => {
                setPageNumber(1);
                setIndicatorsDatasetId(e.target.value);
              }}
              agencyId={agencyId}
              defaultValue={indicatorsDatasetId}
              value={indicatorsDatasetId}
              userId={userType == 3 || userType == 4 ? userId : null}
            />
          </FormGroup>
        </Col>
        <Col md="4">
          <FormGroup>
            <label>ชื่อชุดข้อมูล</label>
            <SelectIndicatorsDatasetKeyinTabs
              placeholder="เลือก"
              name="indicatorsDatasetSettingId"
              disabled={agencyId == null || indicatorsDatasetId  == null || agencyId == 0 || indicatorsDatasetId  == 0}
              onChange={(e) => {
                setPageNumber(1);
                setTableTabSettingId(e.target.value);
              }}
              agencyId={agencyId}
              indicatorsDatasetSettingId={indicatorsDatasetId}
              defaultValue={tableTabSettingId}
              value={tableTabSettingId}
            />
          </FormGroup>
        </Col>
        <Col md="4">
            <FormGroup>
              <label>
                เลือกปี พ.ศ.<span style={{ color: "red" }}>*</span>
              </label>
              <FormSelect
                placeholder="เลือก"
                name="yearId"
                disabled={
                  agencyId == null ||
                  indicatorsDatasetId == null ||
                  agencyId == 0 ||
                  indicatorsDatasetId == 0 ||
                  tableTabSettingId == null ||
                  tableTabSettingId == 0
                }
                onChange={(e) => {
                  setyearId(e.target.value);
                  const yearNo = indicatorsYearsList.filter(item => item.yearId == e.target.value);
                  setyearNo(yearNo[0].yearNo);
                }}
                defaultValue={yearId}
                value={yearId}
              >
                <option value="0">-เลือก-</option>
                {indicatorsYearsList != null &&
                  indicatorsYearsList.length > 0 &&
                  indicatorsYearsList.map((item, key) => (
                    <option key={key} value={item.yearId} title={item.yearNo}>
                      {item.yearNo}
                    </option>
                  ))}
              </FormSelect>
            </FormGroup>
          </Col>
      </Row>
      <Row style={{ marginBottom: 20 }}>
        <Col md={8}>
          <Nav tabs className="status-menu">
            <NavItem>
              <NavLink
                active={status === null ? true : false}
                onClick={() => selectTabs(null)}
              >
                <FontAwesomeIcon icon={faListUl} /> ทั้งหมด
              </NavLink>
            </NavItem>
            {tab.map((item, key) => (
              <NavItem key={key}>
                <NavLink
                  active={status === key ? true : false}
                  onClick={() => selectTabs(key)}
                >
                  {item.icon}
                  {item.title}
                </NavLink>
              </NavItem>
            ))}
          </Nav>
        </Col>
        <Col md={4}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "end",
              flex: 1,
              paddingTop: 5,
            }}
          >
            จำนวนทั้งหมด {total} รายการ
          </div>
        </Col>
      </Row>
      <Row>
        <Col md="12">
          <table className="table mb-0">
            <thead className="thead-dark">
              <tr>
                <th scope="col">รายการข้อมูล/ตัวชี้วัด</th>
                <th scope="col" style={{ width: 80 }}>
                  ปี พ.ศ.
                </th>
                <th scope="col">ผู้อัพเดทข้อมูลล่าสุด</th>
                <th scope="col" style={{ width: 150 }}>
                  วันที่อัพเดทข้อมูล
                </th>
                <th scope="col">สถานะข้อมูล</th>
                <th scope="col" style={{ width: 120 }}>
                  เครื่องมือ
                </th>
              </tr>
            </thead>
            <tbody className="table-middle">
              {PowerbiApproveData != null &&
              PowerbiApproveData.data.length > 0 ? (
                PowerbiApproveData.data.map((item, index) => (
                  <tr key={item.tableHeadId}>
                    <td>
                      <div className="bold">
                        ตัวชี้วัด : {item.indicatorsDatasetSettingId} -{" "}
                        {item.indicatorsDatasetSettingName}
                      </div>
                      <small className="text-black-50">
                        ชุดข้อมูล : {item.tableTabSettingId} -{" "}
                        {item.tableTabSettingName}{" "}
                      </small>

                      {
                        item.indicatorsDatasetSettingId == 20 &&  item.list && item.list.length > 0 && (
                          <small className="text-black-50"> ({item.list[0].Import_Export}) </small>
                        )
                      }
                    </td>
                    <td>
                    <div>
                      {item.yearNo}
                      </div>
                      {
                        item.indicatorsDatasetSettingId == 20 &&  item.list && item.list.length > 0 && (
                        <small className="text-black-50">
                          {getMonthName(item.list[0].Month_No)} 
                        </small>
                        )
                      }
                    </td>
                    <td>
                      <div className="bold">
                        {item.firstName} {item.lastName}
                      </div>
                      <small className="text-black-50">{item.agencyName}</small>
                    </td>
                    <td>{formatDate(item.lastUpdate[0])}</td>
                    <td>{getStatusBadge(item.status)}</td>
                    <td>
                      <a
                        class="btn-link"
                        style={{ float: "left" }}
                        href={`/powerbidetail/${item.tableHeadId}/${item.indicatorsDatasetSettingId}`}
                        role="button"
                      >
                        {item.status == 2 ? "ดูรายละเอียด" : "แก้ไข"}
                      </a>
                      {(item.indicatorsDatasetSettingId ==20 || item.status == 0) && userType === 1 && (
                        <a
                          class="btn-link"
                          style={{
                            color: "red",
                            marginLeft: 15,
                            float: "left",
                          }}
                          onClick={() => {
                            console.log(
                              `คุณต้องการลบชุดข้อมูลนี้ใช่หรือไหม`,
                              item
                            );
                            setTextAlertModal(
                              `คุณต้องการลบชุดข้อมูล "${item.indicatorsDatasetSettingName}" ประจำปี พ.ศ.${item.yearNo} ใช่หรือไหม`
                            );
                            SetOpenModalAlert(true);
                            setPowerbiDeleteData(item);
                          }}
                          role="button"
                        >
                          ลบ
                        </a>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={6}> ยังไม่มีรายการให้อนุมัติ </td>
                </tr>
              )}
            </tbody>
          </table>
        </Col>
        <Col md="12" style={{ textAlign: "right" }}>
          {PowerbiApproveData != null && (
            <ReactPaginate
              pageCount={totalPage}
              forcePage={pageNumber - 1}
              containerClassName="pagination"
              nextLabel=">"
              previousLabel="<"
              onPageChange={({ selected }) => {
                nextPage(selected, totalPage);
              }}
            />
          )}
        </Col>
      </Row>
    </Layout>
  );
};

export default PowerbiApprove;
